import moment from 'moment';

export const getCurrentFinancialYear = () => {
  const now = moment();

  // Financial year in India starts on April 1
  const currentYear = now.year();

  const fyStart =
    now.month() >= 3 // April = 3 in moment.js
      ? moment(`${currentYear}-04-01`, "YYYY-MM-DD")
      : moment(`${currentYear - 1}-04-01`, "YYYY-MM-DD");

  const fyEnd = fyStart.clone().add(1, "year").subtract(1, "day");

  return [fyStart, fyEnd];
};